import { Route } from 'react-router-dom';
import { outOfNavRoutes, routes } from '../utils/constants/adminRoutes';
import { MailSenderRouter } from '../routes/mail-sender/MailSenderRouter';
import { BaseRouter } from './BaseRouter';

export const AdminRouter = () => (
  <BaseRouter
    routes={routes}
    outOfNavRoutes={outOfNavRoutes}
    useIndexForDashboard
    additionalRoutes={[
      <Route
        key="mail-sender"
        path={`${routes.MAIL_SENDER}/*`}
        element={<MailSenderRouter />}
      />
    ]}
  />
);
